const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const MannequinQueryURL: any = {
    GetMannequins: Backofficebff + '/v1/Mannequin/get',
    GetMannequinById: Backofficebff + '/v1/Mannequin/get',
};

